import { Component } from '@/types'

const component: Component = ref => {
  if (!ref.cartCommentModal) return

  ref.cartCommentModal.forEach((modal: HTMLElement) => {
    const closeButtons = modal.querySelectorAll('[data-ref="cart-comment-close"]')
    const saveButton = modal.querySelector('[data-ref="cart-comment-save"]')
    const textarea = modal.querySelector('[data-ref="cart-comment-textarea"]') as HTMLTextAreaElement
    const bg = modal.querySelector('.bg')

    function closeModal() {
      modal.style.display = 'none'
    }

    // Close on cancel button clicks
    closeButtons.forEach(button => {
      button?.addEventListener('click', closeModal)
    })

    // Close on background click
    bg?.addEventListener('click', closeModal)

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        closeModal()
      }
    })

    // Save comment
    saveButton?.addEventListener('click', async () => {
      const comment = textarea?.value || ''

      try {
        // Update cart note via Shopify API
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ note: comment })
        })

        if (!response.ok) {
          throw new Error('Failed to update cart note')
        }

        // Dispatch event to notify other components
        window.dispatchEvent(new CustomEvent('se-event.cart.comment-updated', {
          detail: { note: comment }
        }))

        // Close modal silently
        closeModal()
      } catch (error) {
        console.error('Error saving cart comment:', error)
        // Could show error to user here if needed
      }
    })
  })
}

export function showCartCommentModal() {
  const modal = document.querySelector('[data-ref="cart-comment-modal"]') as HTMLElement
  if (modal) {
    modal.style.display = 'block'

    // Focus textarea when modal opens
    const textarea = modal.querySelector('[data-ref="cart-comment-textarea"]') as HTMLTextAreaElement
    textarea?.focus()
  }
}

export default component
